const Expandable = {

	expandedClass: 'expandable--expanded',

	elements: {},

	toggle(e)
	{
		const button = e.target.closest('.js-expand');

		if( button )
		{
			button.closest('.js-expandable').classList.toggle(this.expandedClass);
		}
	},

	bind()
	{
		Array.prototype.forEach.call(this.elements.expandables, expandable => {
			expandable.addEventListener('click', (e) => {
				this.toggle(e)
			});
		});
	},

	cacheDom()
	{
		this.elements.expandables = document.querySelectorAll('.js-expandable');
	},

	init()
	{
		this.cacheDom();
		this.bind();
	}
};

export default Expandable;